import { Library, Users, BookOpen, ClipboardList, FileText, LogOut, PieChart, Filter, ChevronDown } from 'lucide-react';
import SidebarItem from '../../../components/ui/SidebarItem';
import { useAnalytics } from '../../../contexts/AnalyticsContext';
import { useAuth } from '../../../contexts/authContext';
import Sidebar from '../../../components/ui/SideBar';

export default function AdminSidebar({ children }) {
  let { analytics } = useAnalytics();

  const sidebarLinks = [
    {
      title: 'Analytics',
      icon: <PieChart className="w-5 h-5" />,
      href: '/admin/analytics',
    },
    {
      title: 'Course Management',
      icon: <Library className="w-5 h-5" />,
      href: '/admin/courses',
      badge: analytics.total_courses,
    },
    {
      title: 'Topic Management',
      icon: <Library className="w-5 h-5" />,
      href: '/admin/topics',
    },
    {
      title: 'Academics',
      icon: <Filter className="w-5 h-5" />,
      subLinks: [
        {
          title: 'University',
          href: '/admin/university'
        },
        {
          title: 'Faculty',
          href: '/admin/faculty'
        },
        {
          title: 'Department',
          href: '/admin/department'
        },
      ]
    },
    {
      title: 'Quiz Management',
      icon: <ClipboardList className="w-5 h-5" />,
      href: '/admin/quizzes'
    },
    {
      title: 'Quiz Responses',
      icon: <ClipboardList className="w-5 h-5" />,
      href: '/admin/quizzes/response'
    },
    {
      title: 'Question Bank',
      icon: <BookOpen className="w-5 h-5" />,
      href: '/admin/question-bank'
    }
    // {
    //   title: 'User Management',
    //   icon: <Users className="w-5 h-5" />,
    //   href: '/admin/users'
    // },
    // {
    //   title: 'Resource Management',
    //   icon: <FileText className="w-5 h-5" />,
    //   href: '/admin/resources'
    // },
  ];

  return (
    <Sidebar sidebarLinks={sidebarLinks}>
      {children}
    </Sidebar>
  )
}
